<template>
  <div class="page-max-width">
    <section class="section">
      <h1 class="heading-4">Join Team Teach Starter</h1>
      <blockquote class="display-font">
        While teachers are at the heart of everything we do, our people are the lifeblood. We are
        inclusive. We have agency, commitment, purpose and passion.
      </blockquote>
      <a
        class="button button-primary"
        href="https://teachstarter.bamboohr.com/jobs/"
        title="View Roles"
      >
        View Roles
      </a>
    </section>

    <section class="section_staff">
      <nuxt-img
        v-for="staff_member in page.staff"
        :key="staff_member.image"
        class="staff_member"
        :src="'/images/careers/' + staff_member.image"
        alt="staff_member.alt"
        width="307"
        height="340"
        format="webp"
      />
    </section>

    <section class="section section_values">
      <div v-for="value in page.values" :key="value.title" class="value">
        <h3 class="display-font heading-3">{{ value.title }}</h3>
        <p class="body-copy">
          {{ value.text }}
        </p>
      </div>
    </section>

    <section class="section section_quote">
      <div class="staff_quote">
        <blockquote class="display-font">
          &#8220;The great thing about Teach Starter (is) you can take a project and own it and see
          it right to the end. You see the result of your input. It&#8217;s inspiring to know it
          matters.&#8221;
        </blockquote>
        <cite>Melissa Beazley</cite>
      </div>
    </section>

    <section class="section container">
      <div v-for="card in page.selling_point_cards" :key="card.title" class="feature-card">
        <div class="text-container" :class="[card.background_color]">
          <h2 class="body-copy bold">{{ card.title }}</h2>
          <p class="body-copy">
            {{ card.text }}
          </p>
          <nuxt-img :src="'/images/careers/' + card.icon_name" alt="" width="32" height="32" />
        </div>
      </div>
    </section>

    <section class="section section_benefits">
      <div v-for="benefit in page.benefits" :key="benefit.title" class="benefit">
        <span>
          <nuxt-img
            :src="'/images/careers/' + benefit.icon_name"
            alt=""
            width="20"
            height="20"
            class="benefit_icon"
          />
          <h2 class="display-font heading-3 benefit_heading">{{ benefit.title }}</h2>
        </span>
        <p class="body-copy">
          {{ benefit.text }}
        </p>
      </div>
    </section>

    <section class="section">
      <p class="heading-4">Join Team Teach Starter</p>
      <blockquote class="display-font">
        We&#8217;ve got some great roles going and we would love to chat about our existing and
        upcoming roles.
      </blockquote>
      <a
        class="button button-primary"
        href="https://teachstarter.bamboohr.com/jobs/"
        title="View Roles"
      >
        View Roles
      </a>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Careers',
  async asyncData() {
    const data = { page: null };

    try {
      const page = await import('@/data/careers.json');
      if (page) {
        data.page = page;
      }
    } catch (error) {
      console.log(error);
    }

    return data;
  },
  data() {
    return {
      title: 'Join Team Teach Starter',
      description:
        "We've got some great roles going and we would love to chat about our existing and upcoming roles.",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>
<style lang="scss" scoped>
@import '~/assets/scss/components/_feature_card.scss';
.section {
  padding: 1.25rem 0;
  max-width: 52.5rem;
  margin: 0 2.25rem;
}
.heading-4 {
  text-transform: uppercase;
  margin: 0;
  font-family: poppins, sans-serif;
}
blockquote {
  margin: 1rem 0;
  font-size: $new-font-size-600;
  line-height: 1.5rem;
}
.staff_quote {
  border-left: $orange-500 0.5rem solid;
  padding-left: 1rem;
  blockquote {
    padding-top: 0;
  }
}
.handshake_icon {
  display: inline-block;
}
.benefit_icon {
  width: 1.25rem;
  height: 1.25rem;
}
.section_benefits {
  display: flex;
  flex-wrap: wrap;
}
.value,
.benefit {
  margin-bottom: 3rem;
}
.value:last-child {
  margin-bottom: 0;
}
.benefit_heading {
  margin-top: 0.5rem;
}
.staff_member {
  width: 100%;
  height: fit-content;
  margin-right: 2rem;
  border-radius: 1rem;
}
.section_staff {
  display: flex;
  overflow: auto;
  padding: 0 0.75rem;
  &:last-child {
    margin-right: 0;
  }
  white-space: nowrap;
}
.section_story {
  border-radius: 1rem;
  background-image: url('/images/patterns/beige_notebook.png');
  background-color: $beige-500;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  .story_content {
    a {
      margin-top: 2.5rem;
    }
  }
}
.section_values,
.section_quote {
  margin-top: 0;
  margin-bottom: 0;
}
.join_button {
  display: flex;
  width: fit-content;
  img {
    display: inline-block;
    margin-right: 0.5rem;
  }
}

@media #{$small-up} {
  blockquote {
    line-height: 2rem;
    font-size: $new-font-size-700;
  }
  .section {
    margin: 1.5rem 3rem;
  }
  .section_benefits {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .benefit {
      width: calc(50% - 3rem);
      margin-bottom: 3rem;
      margin-right: 1.5rem;
    }
  }
  .section_story {
    padding: 5rem;
    .story_content {
      margin-left: 3rem;
    }
  }
}

@media #{$large-up} {
  .section {
    margin-left: auto;
    margin-right: auto;
  }
  .section_staff {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    height: 47.5rem;
    background-image: url('/images/shapes/pink_seed_2.png');
    background-color: white;
  }
  .section_story {
    flex-direction: row;
  }
  .staff_member {
    width: 19.1875rem;
    margin-right: 2rem;
  }
  .staff_member:nth-of-type(1) {
    margin-top: 10.125rem;
    margin-left: 5rem;
  }
  .staff_member:nth-of-type(2) {
    margin-top: 14.125rem;
  }
  .staff_member:nth-of-type(3) {
    margin-top: 7rem;
  }
  .staff_member:nth-of-type(4) {
    margin-top: 12.625rem;
    margin-right: 0;
  }
  .container {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .benefit_heading {
    margin-left: 0.5rem;
    margin-top: 0;
  }
  .benefit_heading,
  .benefit_icon {
    display: inline-block;
  }
}
</style>
